export const CONST_PRODUCT_SERIAL = 1
